import { IconContentTrash } from '@doltech/icons/IconContentTrash';
import { Popconfirm } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../../figma/colors-v2';

const Main = styled.button`
  &&& {
    cursor: pointer;
    outline: none;
    background-color: transparent;
    border: none;
    font-size: 24px;
    line-height: 0;
    color: ${colorsV2.black80};
    transition: all 0.2s ease;
    padding: 0;
    &:hover {
      background-color: transparent;
      color: ${colorsV2.primary100};
    }
    &:active {
      transform: scale(0.96);
    }
  }
`;

interface ButtonDeleteProps {
  confirmDeleteTitle?: string;
  onConfirm: () => void;
}

export const ButtonDelete = ({ confirmDeleteTitle, onConfirm }: ButtonDeleteProps) => {
  return (
    <Popconfirm
      title={confirmDeleteTitle || 'Are you sure to delete this?'}
      onConfirm={onConfirm}
      okText="Yes"
      cancelText="No"
    >
      <Main contentEditable={false} className="delete-button">
        <IconContentTrash />
      </Main>
    </Popconfirm>
  );
};
